import instance from "@/services/api";
import { API_URL, PAGES, AUTH_TYPE } from "@/constants";
import cookiesService from "@/services/cookiesService";

const SILENT_TRIED_KEY = "kc_silent_tried";

export function isKeycloakAuthType() {
  return cookiesService.getService().getAuthType() === AUTH_TYPE.keycloak;
}

export async function fetchSsoConfig() {
  try {
    const res = await instance(false, null, { showToast: false }).get(
      "/auth/keycloak/sso-config/"
    );
    return res?.data || { enabled: false, silent: false, links: [] };
  } catch (e) {
    return { enabled: false, silent: false, links: [] };
  }
}

export function safeDest(dest) {
  // Разрешаем только внутренний путь (без перехода на чужой origin) и не на сам логин.
  if (!dest || typeof dest !== "string") return "";
  if (!dest.startsWith("/") || dest.startsWith("//")) return "";
  if (dest.startsWith(PAGES.login) || dest.startsWith(PAGES.loginKeycloakCallback)) return "";
  return dest;
}

export function getKeycloakStartUrl(prompt, dest) {
  const base = (API_URL || "").replace(/\/$/, "");
  let callback = `${window.location.origin}${PAGES.loginKeycloakCallback}`;
  const cleanDest = safeDest(dest);
  if (cleanDest) callback += `?dest=${encodeURIComponent(cleanDest)}`;
  const params = new URLSearchParams({ next: callback });
  if (prompt) params.set("prompt", prompt);
  return `${base}/auth/keycloak/start/?${params.toString()}`;
}

export function goToKeycloak(prompt, dest) {
  window.location.assign(getKeycloakStartUrl(prompt, dest));
}

/**
 * Сквозной переход в соседнюю систему без повторного ввода пароля.
 * Берёт текущий Keycloak refresh, меняет его на одноразовый код через бэкенд (issue),
 * затем редиректит на sso-ingest соседней системы. Возвращает true, если переход начат.
 */
export async function ssoHandoffJump(dest) {
  const cfg = await fetchSsoConfig();
  if (!cfg?.handoff_enabled || !cfg?.handoff_ingest_url) return false;
  const refresh = cookiesService.getService().getRefreshToken();
  if (!refresh) return false;
  try {
    const res = await instance(false, null, { showToast: false }).post(
      "/auth/keycloak/sso/issue/",
      { refresh }
    );
    const code = res?.data?.code;
    const ingest = res?.data?.ingest_url || cfg.handoff_ingest_url;
    const src = res?.data?.src || cfg.handoff_src;
    if (!code || !ingest) return false;
    let url = `${ingest}?code=${encodeURIComponent(code)}&src=${encodeURIComponent(src)}`;
    const cleanDest = safeDest(dest);
    if (cleanDest) url += `&dest=${encodeURIComponent(cleanDest)}`;
    window.location.assign(url);
    return true;
  } catch (e) {
    return false;
  }
}

export function silentSsoAlreadyTried() {
  try {
    return sessionStorage.getItem(SILENT_TRIED_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function markSilentSsoTried() {
  try {
    sessionStorage.setItem(SILENT_TRIED_KEY, "1");
  } catch (e) {
    /* noop */
  }
}

export function resetSilentSso() {
  try {
    sessionStorage.removeItem(SILENT_TRIED_KEY);
  } catch (e) {
    /* noop */
  }
}
